import { get } from './index';

async function allAttr(func) {
    await get('/api/allAttr').then(response => func(response.data) );
}

export default {
    allAttr
}